// Estimation Calculations - Pure calculation logic for campaign estimations
// This file contains calculation functions that can be imported and reused

export class EstimationCalculations {
  // Calculate total budget allocation
  static calculateTotalAllocation(tactics) {
    return tactics.reduce((sum, tactic) => {
      return sum + (parseInt(tactic.budget_allocation) || 0);
    }, 0);
  }

  // Calculate remaining budget
  static calculateRemainingBudget(campaignBudget, totalAllocated) {
    return campaignBudget - totalAllocated;
  }

  // Calculate remaining percentage
  static calculateRemainingPercent(campaignBudget, remainingBudget) {
    if (campaignBudget === 0) return 0;
    return Math.round((remainingBudget / campaignBudget) * 100);
  }



  // Calculate total estimated downloads
  static calculateTotalEstimatedDownloads(tactics) {
    return tactics.reduce((sum, tactic) => {
      const downloads = tactic.estimated_downloads || 0;
      return sum + downloads;
    }, 0);
  }

  // Calculate total estimated impressions
  static calculateTotalEstimatedImpressions(tactics) {
    return tactics.reduce((sum, tactic) => {
      const impressions = tactic.estimated_impressions || 0;
      return sum + impressions;
    }, 0);
  }

  // Validate tactic configuration
  static isTacticValid(tactic) {
    return tactic.selected_vendor && 
           tactic.budget_allocation >= tactic.minimum_spend &&
           tactic.budget_allocation % 5 === 0;
  }

  // Validate form data
  static validateForm(tactics, campaignBudget) {
    const errors = {};
    const totalAllocated = this.calculateTotalAllocation(tactics);
    
    if (totalAllocated !== campaignBudget) {
      errors.budget = `Total allocation must equal campaign budget. Current: $${totalAllocated}, Required: $${campaignBudget}`;
    }
    
    tactics.forEach((tactic, index) => {
      if (!this.isTacticValid(tactic)) {
        errors[`tactic_${index}`] = 'Invalid tactic configuration';
      }
    });
    
    return {
      isValid: Object.keys(errors).length === 0,
      errors: errors
    };
  }

  // Calculate percentage from budget allocation
  static calculatePercentageFromBudget(budgetAllocation, campaignBudget) {
    if (campaignBudget === 0) return 0;
    return Math.round((budgetAllocation / campaignBudget) * 100);
  }

  // Calculate budget allocation from percentage
  static calculateBudgetFromPercentage(percentage, campaignBudget) {
    return Math.round((percentage / 100) * campaignBudget);
  }

  // Check if budget allocation meets minimum spend
  static meetsMinimumSpend(budgetAllocation, minimumSpend) {
    return budgetAllocation >= minimumSpend;
  }

  // Format number with commas
  static formatNumber(number) {
    return number.toLocaleString();
  }

  // Format currency
  static formatCurrency(amount) {
    return `$${amount.toLocaleString()}`;
  }
}
